import { EVENT_DATA } from '../actionType/eventType';

export const eventDataRequest = () => ({
  type: EVENT_DATA.LOAD,
});
